import { Component } from '@angular/core';
import { SmartWalletService } from './services/smart-wallet.service';
import { StarlyToastService } from './services/starly-toast.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  private authenticationToastId: number | null = null;
  constructor(private smartWalletService: SmartWalletService, private starlyToastService: StarlyToastService) {
    this.smartWalletService.isAuthenticated$.subscribe((isAuthenticated: boolean) => {
      if (!isAuthenticated) {
        this.authenticationToastId = this.starlyToastService.present({
          status: 'info',
          title: 'Hey, I’m Starly! Let’s go on an adventure!',
        });
      } else {
        if (this.authenticationToastId) {
          this.starlyToastService.remove(this.authenticationToastId);
        }
      }
    });
  }
}
